import React, { FC } from "react";

import SidebarMenu from "./SidebarMenu";

const Sidebar: FC = () => (
  <div>
    <div className="panel-overlay" style={{ marginLeft: 260 }}></div>
    <div className="panel panel-left">
      <SidebarMenu />
    </div>
  </div>
);
export default Sidebar;
